import type { FC, ReactNode } from 'react'
import { cn } from '@/helpers/utils'

type IconContainerSize = 'md' | 'lg'
type IconContainerType = 'neutral' | 'danger' | 'success' | 'warning' | 'blue'

const sizeStyles: Record<IconContainerSize, string> = {
	md: 'h-10 w-10 [&_svg]:w-5',
	lg: 'h-12 w-12 [&_svg]:w-6'
}

const typeStyles: Record<IconContainerType, string> = {
	neutral: 'bg-transparent border-neutral-600',
	danger: 'bg-danger-600 border-danger-200',
	warning: 'bg-warning-600 border-warning-200',
	success: 'bg-success-600 border-success-200',
	blue: 'bg-blue-600 border-blue-200'
}

interface IconContainerProps {
	children: ReactNode
	size?: IconContainerSize
	type?: IconContainerType
}

export const IconContainer: FC<IconContainerProps> = ({
	children,
	size = 'md',
	type = 'neutral'
}) => {
	return (
		<div
			className={cn(
				'flex shrink-0 items-center justify-center rounded-xl border',
				sizeStyles[size],
				typeStyles[type]
			)}
		>
			{children}
		</div>
	)
}

IconContainer.displayName = 'IconContainer'
